import { MutationTree } from 'vuex';
import { ESearchMutation, ESearchState } from '@/content-library/search/store/search.constants';
import { ISearchState } from '@/content-library/search/store/search.types';
import { IAutocompleteSuggestion } from '@/content-library/search/types/search';

export const mutations: MutationTree<ISearchState> = {
  [ESearchMutation.SetRecentSearches](state: ISearchState, recentSearches: string[]) {
    state[ESearchState.RecentSearches] = recentSearches;
  },
  [ESearchMutation.SetAutocompleteSuggestions](
    state: ISearchState,
    autocompleteSuggestions: IAutocompleteSuggestion[]
  ) {
    state[ESearchState.AutocompleteSuggestions] = autocompleteSuggestions;
  },
  [ESearchMutation.SetLoaded](state: ISearchState, loaded: boolean) {
    state[ESearchState.Loaded] = loaded;
  },
  [ESearchMutation.SetLoading](state: ISearchState, loading: boolean) {
    state[ESearchState.Loading] = loading;
  },
};
